import { render, staticRenderFns } from "./StudioAdmin.vue?vue&type=template&id=2fafb9c0"
import script from "./StudioAdmin.vue?vue&type=script&lang=js"
export * from "./StudioAdmin.vue?vue&type=script&lang=js"
import style0 from "./StudioAdmin.vue?vue&type=style&index=0&id=2fafb9c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports